module.exports = __webpack_public_path__ + "img/clock_outline.b077259b.svg";